/**
 * Что показать в курсорном списке (лента отзывов, «Мои отзывы»): индикатор первой загрузки,
 * ошибку с «Повторить», «нет отзывов» или «Показать ещё». Сбой загрузки — не «пустой список»:
 * уже загруженные отзывы остаются, а вместо «Показать ещё» показывается повтор.
 * Сбой сбрасывается только успешной загрузкой.
 */
export type ListingViewState = {
  /** Идёт запрос */
  pending: boolean
  /** Сколько элементов уже показано */
  count: number
  /** Последняя загрузка не удалась */
  failed: boolean
  /** Есть следующая страница */
  hasAfter: boolean
}

export type ListingView = {
  /** Индикатор вместо списка — первая загрузка */
  loading: boolean
  /** «Не удалось загрузить» и «Повторить» */
  failed: boolean
  /** «Отзывов пока нет» */
  empty: boolean
  /** «Показать ещё» */
  more: boolean
}

export function listingView(state: ListingViewState): ListingView {
  // Блок ошибки держится и во время повтора: кнопка «Повторить» показывает загрузку
  return {
    loading: state.pending && state.count === 0 && !state.failed,
    failed: state.failed,
    empty: !state.pending && !state.failed && state.count === 0,
    more: state.hasAfter && state.count > 0 && !state.failed,
  }
}
